import template from './form.html';
import { FormActions } from 'core/services/form';
import configFile from 'config.json';
import { rest } from 'core/api';
import usuariosI18N from 'i18n/usuarios/es.json';
import commonI18N from 'i18n/common/es.json';
import { formatErrorMessage } from 'core/util';

export let UsuarioFormComponent = {
  templateUrl: template,
  selector: 'usuarioForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(usuariosI18N).concat(Object.keys(commonI18N));


FormController.$inject = ['$state', '$ngRedux', 'ngNotify', '$stateParams', '$timeout', '$scope'];

function FormController($state, $ngRedux, ngNotify, $stateParams, $timeout, $scope) {
  this.uploadOptions = {
    imageOnly: true,
    target: configFile.serverURL + '/adjuntos',
    publicPath: configFile.publicURL
  };
  this.cancel = cancel.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.syncPasswords = syncPasswords.bind(this);
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.localModel = {};

  this.$onInit = () => {
    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver usuario'] : this.translations['Editar usuario'];
      this.formEdit('usuarios', $stateParams.uid);
      this.localModel.cambiarPassword = false;
    } else {
      this.title = this.translations['Nuevo usuario'];
      this.form();
      this.localModel.cambiarPassword = true;
    }
    $ngRedux.dispatch(rest.actions.sucursales.get());
    $ngRedux.dispatch(rest.actions.roles.get());
  };

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.model = state.form.model;

    if (this.model) {
      this.model.repeatPassword = this.model.password;
    }
    this.listadoSucursales = state.sucursales.data;
    this.listadoRoles = state.roles.data;
    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    return { form: state.form, sucursales: state.sucursales };
  }

  /**
   * Función que se encarga de mostrar mensajes de error en base al estado actual
   * 
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.usuarios.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go('home.usuarios.list');
    }

    if (state.sucursales.error) {
      ngNotify.set(state.sucursales.error.message, 'error');
    }

    if (state.roles.error) {
      ngNotify.set(state.roles.error.message, 'error');
    }
  }


  /**
   * Cancela el formulario y retorna al listado
   */
  function cancel() {
    $state.go('home.usuarios.list');
  }

  function doSubmit() {
    if ($scope.usuarioForm.$invalid) {
      this.submitted = true;
      return;
    }

    if (this.model.password !== this.model.repeatPassword) {
      this.ngNotify.set(this.translations['La contraseña y su confirmación no coinciden'], 'error');
      return;
    }
    var data = Object.assign({}, this.model);

    if (this.model.foto && this.model.foto.length) {
      data.foto = this.model.foto[0];
    }

    if (!this.model.sucursales) {
      data.sucursales = [];
    }

    data.cambiarPassword = this.localModel.cambiarPassword;
    delete data.repeatPassword;
    this.save('usuarios', data);
  }

  /**
   * on-change handler para el campo generatedPassword.
   */
  function syncPasswords(password) {
    this.model.password = password;
    this.model.repeatPassword = password;
  }
}


// WEBPACK FOOTER //
// ./src/components/usuarios/form/form.component.js